<template>
  <div
    class="relative grid h-full w-full grid-cols-3 overflow-hidden rounded-sm bg-primary-100"
  >
    <app-image
      v-for="teacher in selection"
      :key="teacher.id"
      :alt="teacher.full_name!"
      class="h-full object-cover"
      :src="teacher.avatar_url"
      :width="100"
    />
    <div
      class="absolute inset-0 bg-black/30 transition group-hover:opacity-0"
    />
    <div class="absolute inset-0 grid place-content-center">
      <app-icon
        class="rounded-full bg-white p-1 transition group-hover:scale-50 group-hover:opacity-0"
        icon="ph:skip-forward-fill"
        :size="20"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
const { data } = useTeacherList(
  "pinned_teachers",
  {
    pinned: true,
    limit: 15,
  },
  {
    server: false,
    lazy: true,
    dedupe: "defer",
  },
);

const selection = computed(() => shuffle(data.value).slice(0, 3));
</script>
